<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="blk1">
                       <img src="./image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                       <div class="blkps">
                       <div class="blkrect"></div>
                       <div class="txtku1">资产列表</div>
                       <div class="txtku2">资产查看</div>
                      </div>
                    </div>
                    <div>
                        <div class="engSty" v-for="(item,index) in m_item" :key="index" @click="tDetail(item)">
							  <div class="tSty"><img class="imgut" :src="item.ifont"/></div>
							  <div class="tSty1">{{item.assetsName}}</div>
							  
                        </div>
                    </div>
                </div>

            </div>
        </div>
     </div>


</template>
<script>
    import PJXQ from '@/components/pjxq.vue'
    export default{
        components:{PJXQ},
        data(){
            return {
                dInfo:'',
                m_item:[
					{id:1,assetsName:'硬件资产',ifont:require('./image/img1.png')},
					{id:2,assetsName:'软件资产',ifont:require('./image/img2.png')},
				]
            }
        },
        methods:{
            tDetail(item){
               if(item.id==1){
				   this.$router.push({path:'/yjCapital'})
			   }else if(item.id==2){
				   this.$router.push({path:'/rjCapital'})
			   }
            },
        },
        created(){
            
        },
		mounted(){
		}
    }

</script>
<style scoped>
     .wrap{
            position: absolute;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            z-index:1000;
            overflow: auto;
            background:#e9eef2;
			overflow-x:hidden;
        }
        .wrap_inner{
             min-height: 100%;
             width:100%;
        }
        .wrap_main{
            padding-bottom: 20px;
        }
    .mainlist{
        width:100%;
        height:340px;
    }
    .img1{
        width:25px;
        height:25px;
    }
    .blk1{
        position:relative;
        width: 100%;
        height: 148px;
    }
    .txt1{
        font-size:16px;
        margin-left:16px;
        color:#333
    }
    .nData{
        width:100%;
        height:200px;
        display:flex;
        justify-content:center;
        align-items:center;
        font-size:14px;
    }	
	.imgut{
		width:45px;
		height:45px;
	}
    .field1{
        width:100%;
        height:35px;
        line-height:35px;
        padding:0;
    }
    .engSty{
		display: flex;
        width: 309px;
        height: 40px;
		line-height:40px;
        padding:18px 12px;
        margin:15px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
        .notice{
            display:flex;
            width: 90%px;
            height: 35px;
            padding:0 5%;
            margin:0px auto;
            background: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
            font-size:12px;
            align-items:center;
            justify-content:center;
        }
        .notice>div{
            flex:1;
        }
        .notice>div:nth-child(1){
            flex:0 0 19px;
        }
        .notice>div:nth-child(3){
            flex:0 0 22px;
        }
        .tSty{
			flex:0 0 60px;
        }
		.tSty1{
			flex:1;
			overflow:hidden;
			text-overflow:ellipsis;
			white-space:nowrap;
		    font-size: 20px;
		    font-weight: 400;
		    color: #333333;
		}
        .subtSty{
			overflow:hidden;
			　　text-overflow:ellipsis;
			　　white-space:nowrap;
            margin-top:3px;
            font-size: 9px;
            font-weight: 400;
            color: #333333;
        }
        .search{
            width: 57px;
            height: 23px;
            background: linear-gradient(116deg,#36b3fe 11%, #0080ff 91%);
            border-radius: 12px;font-size:14px;color:#fff;text-align:center;
            line-height:23px;
        }
        .blkps{
            position:absolute;
            top:35px;
            right:0px;
            width:142px;
            height:90px;
        }
        .blkrect{
            width: 20px;
            height: 2px;
            background: #ffffff;
        }
        .txtku1{
            margin:4px 0 10px 0;
            font-size: 20px;
            font-weight: 800;
            text-align: left;
            color: #ffffff;
        }
        .txtku2{
            font-size: 16px;
            font-weight: 400;
            color: rgba(255,255,255,0.80);
        }
		/deep/ .van-icon::before {
		    display: inline-block;
		    color: #0080ff;
		    font-size: 40px;
		}
</style>
